export default __webpack_public_path__ + "static/partner_page_mural-7f9773ac6b0e70c01e3107545b3254c5.png";